/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import sysJwt from "../../../utils/sysJwt";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { confirmAlert } from "react-confirm-alert";
import GridTable from "@nadavshaar/react-grid-table";

class Slider extends Component {
  state = {
    data: {
      imgOrder: "",
      fileEn: null,
      fileAr: null,
      fileKu: null,
    },

    contentHeader: "شريط الصور",
    addButtonLabel: "اضافة صورة",
    addButtonIcon: "fa fa-plus",

    dataUrl: "/api/data/GeSliders",
    singleItemUrl: "/api/data/GetSlider",
    addUrl: "/api/data/AddSlider",
    editUrl: "/api/data/EditSlider",
    deleteUrl: "/api/data/DeleteSlider",

    inEditMode: false,
    inModalMode: false,
    modalHeaderAdd: "اضافة صورة",
    modalSubmitButtonLabelAdd: "اضافة",
    modalSubmitButtonIconAdd: "fa fa-plus",
    modalHeaderEdit: "تعديل صورة",
    modalSubmitButtonLabelEdit: "تعديل",
    modalSubmitButtonIconEdit: "fa fa-edit",
    modalWidth: "50vw",

    editEntityId: 0,

    tableData: [],
    tableColumns: [
      {
        id: 1,
        label: "التسلسل",
        field: "IMG_ORDER",
      },
      {
        id: 2,
        label: "تاريخ الادخال",
        field: "INSERT_DATE",
      },
      {
        id: 3,
        label: "تاريخ التعديل",
        field: "LAST_UPDATE",
      },
      {
        id: 4,
        field: "IMG_PATH_AR",
        label: "الصورة عربي",
        cellRenderer: ({ data }) => {
          return (
            <a
              href={data.IMG_PATH_AR}
              target="blank"
              style={{ color: "black" }}
            >
              View File
            </a>
          );
        },
      },
      {
        id: 5,
        field: "IMG_PATH_EN",
        label: "الصورة انكليزي",
        cellRenderer: ({ data }) => {
          return (
            <a
              href={data.IMG_PATH_EN}
              target="blank"
              style={{ color: "black" }}
            >
              View File
            </a>
          );
        },
      },
      {
        id: 6,
        field: "IMG_PATH_KU",
        label: "الصورة كردي",
        cellRenderer: ({ data }) => {
          return (
            <a
              href={data.IMG_PATH_KU}
              target="blank"
              style={{ color: "black" }}
            >
              View File
            </a>
          );
        },
      },
      {
        id: 7,
        label: "الأوامر",
        field: "SYS_ACTINOS",
        width: "80px",
        maxResizeWidth: "100px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => {
          return (
            <div id="outer">
              {sysJwt.isAuthorized(["CB0D"]) && (
                <div className="inner" title="حذف">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => this.handleDelete(data)}
                  >
                    <i className="fa fa-trash" />
                  </button>
                </div>
              )}
            </div>
          );
        },
      },
    ],
  };

  componentDidMount() {
    this.getData();
  }

  updateForm = (inputId, inputValue) => {
    var data = this.state.data;
    data[inputId] = inputValue;
    this.setState({ data });
  };

  showForm() {
    this.setState({ inModalMode: true });
  }

  closeModal() {
    var data = this.state.data;

    Object.keys(data).forEach(function (key) {
      Array.isArray(data[key]) ? (data[key] = []) : (data[key] = "");
    });

    this.setState({
      inModalMode: false,
      inEditMode: false,
      data: data,
      editEntityId: 0,
    });

    this.getData();
  }

  getData() {
    post(this.state.dataUrl, null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({ tableData: apiResponse.data.respData.data });
      }
    );
  }

  getEditFormData(row) {
    return post(
      this.state.singleItemUrl,
      { id: row.ID },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      var data = this.state.data;

      data["imgOrder"] = apiResponse.data.respData.data[0].IMG_ORDER;

      this.setState({
        data: data,
        editEntityId: apiResponse.data.respData.data[0].ID,
      });
    });
  }

  handleDelete(row) {
    confirmAlert({
      title: "حذف الصورة",
      message: "هل أنت متأكد من حذف هذه الصورة",
      buttons: [
        {
          label: "نعم",
          onClick: () => {
            post(
              this.state.deleteUrl,
              { id: row.ID },
              this.props.updateIsLoading
            ).then((apiResponse) => {
              apiResponse.data.respCode === 0 ? this.getData() : null;
            });
          },
        },
        {
          label: "الغاء",
          onClick: () => null,
        },
      ],
    });
  }

  doSubmit() {
    const submitData = Object.assign({}, this.state.data);

    if (this.state.inEditMode) {
      submitData["id"] = this.state.editEntityId;
    }

    const data = new FormData();
    if (this.state.data.fileEn && this.state.data.fileEn !== null) {
      data.append(
        "fileEn",
        this.state.data.fileEn,
        this.state.data.fileEn.name
      );
    }
    if (this.state.data.fileAr && this.state.data.fileAr !== null) {
      data.append(
        "fileAr",
        this.state.data.fileAr,
        this.state.data.fileAr.name
      );
    }
    if (this.state.data.fileKu && this.state.data.fileKu !== null) {
      data.append(
        "fileKu",
        this.state.data.fileKu,
        this.state.data.fileKu.name
      );
    }

    data.append("requestData", JSON.stringify(submitData));

    post(
      this.state.inEditMode ? this.state.editUrl : this.state.addUrl,
      data,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
      }
    });
  }

  render() {
    return (
      <div className="sys-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{this.state.contentHeader}</h4>
          </div>
          <div className="col flex-container-left">
            {sysJwt.isAuthorized(["CB0C"]) && (
              <Button
                label={this.state.addButtonLabel}
                icon={this.state.addButtonIcon}
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => {
                  this.setState({ inEditMode: false });
                  this.showForm();
                }}
              />
            )}
          </div>
        </div>
        <hr />
        <Dialog
          visible={this.state.inModalMode}
          style={{ width: this.state.modalWidth }}
          onHide={(e) => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={
            <h5 className="modal-header">
              {this.state.inEditMode
                ? this.state.modalHeaderEdit
                : this.state.modalHeaderAdd}
            </h5>
          }
          footer={
            <div>
              <Button
                label={
                  this.state.inEditMode
                    ? this.state.modalSubmitButtonLabelEdit
                    : this.state.modalSubmitButtonLabelAdd
                }
                icon={
                  this.state.inEditMode
                    ? this.state.modalSubmitButtonIconEdit
                    : this.state.modalSubmitButtonIconAdd
                }
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doSubmit()}
              />
              <Button
                label="الغاء"
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={this.state.inEditMode}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              {
                type: "text",
                id: "imgOrder",
                label: "تسلسل الصورة",
                disabled: false,
              },
              {
                type: "fileupload",
                id: "fileAr",
                label: "الصورة عربي",
                disabled: false,
              },
              {
                type: "fileupload",
                id: "fileEn",
                label: "الصورة انكليزي",
                disabled: false,
              },
              {
                type: "fileupload",
                id: "fileKu",
                label: "الصورة كردي",
                disabled: false,
              },
            ]}
          />
        </Dialog>
        <GridTable
          columns={this.state.tableColumns}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 30, 40]}
          showColumnVisibilityManager={false}
          texts={{
            search: "بحث:",
            totalRows: "إجمالي عدد البيانات:",
            rows: "الصف:",
            selected: "المحدد",
            rowsPerPage: "عدد الصفوف في الصفحة:",
            page: "الصفحة:",
            of: "من",
            prev: "السابق",
            next: "التالي",
            columnVisibility: "اظهار الاعمدة",
          }}
        />
      </div>
    );
  }
}

export default Slider;
